import React from "react";

const LoginPage = () => {
  return (
    <div className="container login-container" style={{ marginTop: "100px" }}>
      <div className="row justify-content-center">
        <div className="col-md-5">
          <div
            className="card login-card"
            style={{
              borderRadius: "10px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <div className="card-body p-4">
              <h3 className="text-center mb-4">เข้าสู่ระบบ</h3>
              <form onSubmit={(e) => handleLogin(e)}>
                <div className="form-group">
                  <label htmlFor="email">อีเมล</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="กรอกอีเมล"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password">รหัสผ่าน</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    placeholder="กรอกรหัสผ่าน"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-block">
                  เข้าสู่ระบบ
                </button>
              </form>
              <div className="text-center mt-3">
                <small>
                  ยังไม่มีบัญชี? <a href="#">สมัครสมาชิก</a>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ฟังก์ชัน login (แก้ไขตามจริง)
const handleLogin = (e) => {
  e.preventDefault();
  const email = e.target.email.value;
  const password = e.target.password.value;

  // ส่งข้อมูลไปยัง backend (แก้ path ตามจริง)
  fetch("https://programmerminidotcom.jnconstructiondesign.co.th/api/login.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  })
    .then((res) => res.json())
    .then((data) => {
      alert("Login result: " + data.message);
      // handle redirect here
    })
    .catch((err) => {
      console.error("Login error:", err);
      alert("เกิดข้อผิดพลาดในการเข้าสู่ระบบ");
    });
};

export default LoginPage;
